// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2OAI6","header":"PatientBlock_header__2OcBI","label":"PatientBlock_label__1g80S","option":"PatientBlock_option__wmEAn"};